__webpack_require__.p = "/ayvakam/";